/* eslint no-console: off */
import { useRouter } from 'next/router';
import { textCancell } from '../../src/components/MockData/MockData';
import ClientLayout from '../../src/layouts/client/ClientLayout';
import MetaHeader from '../../src/components/MetaHeader';
import { textConfig } from '../../constants/textLang';

const Cancellation = () => {
    const router = useRouter();
    const { locale } = router;
    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="cancellation-content">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{textCancell[locale].head_title}</h1>
                    </div>
                    <div className="main-content-text">
                        <div className="text">
                            <p>{textCancell[locale].text_one}</p>
                        </div>
                        <div className="text">
                            <p>{textCancell[locale].text_two}</p>
                        </div>
                        <div className="text-center">
                            <p>{textCancell[locale].specification}</p>
                        </div>
                        <div className="table-data">
                            <table className="table-specification">
                                <tbody>
                                    {textCancell[locale].text_table.map(
                                        (itemTable, indexTable) => (
                                            <tr key={indexTable}>
                                                <td>{itemTable.text_one}</td>
                                                <td>{itemTable.text_two}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-detail">
                            <span>{textCancell[locale].text_three}</span>
                        </div>
                        <ol className="text-detail">
                            {textCancell[locale].text_detail.map(
                                (itemDetail, indexDetail) => (
                                    <li key={indexDetail}>{itemDetail}</li>
                                )
                            )}
                        </ol>
                        <p className="text-more">
                            {textCancell[locale].text_more}
                        </p>
                        <div className="text-bottom">
                            <a href="https://line.me/R/ti/p/@271qmttm?ts=05202119&oat_content=url">
                                {textCancell[locale].text_social_contact.line} /
                            </a>
                            <a href="mailto:vip29@pinvest.co.th">
                                {textCancell[locale].text_social_contact.email}{' '}
                                /
                            </a>
                            <a href="tel:+66646424915">
                                {textCancell[locale].text_social_contact.call}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </ClientLayout>
    );
};

export const getStaticProps = async (ctx) => {
    const { locale } = ctx;
    const meta = {
        title: textConfig[locale]?.title_cancellation,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Cancellation Page',
        image: 'main-pic.jpeg',
    };

    return {
        props: { meta },
    };
};

export default MetaHeader(Cancellation);
